// import { useLang } from '../../context/LangContext';
// import { Icon } from '../../icons/Icons';
import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { useTranslations } from 'next-intl';
import { useLayoutContext } from '@/context/LayoutContext';

/** Floating "live vehicle status" card shown before a lookup is run. */
export function HeroVisual() {
  const { footerSubCategory, priceSymbol } = useLayoutContext();
  const t = useTranslations('HomePage.hero');
  const hero = {
    cardTitle: t('visual.title'),
    cardLive: t('visual.tag'),
    scoreLabel: t('visual.float.text'),
    cardRows: [
      {
        icon: <MainIcons.flashIcon fill="#fff" />,
        t: 'خلافی خودرو',
        d: 'بدهی',
        v: 'ندارد',
        bg: 'linear-gradient(135deg,var(--accent),var(--pink))',
      },
      {
        icon: <MainIcons.shieldIcon fill="#fff" />,
        t: 'تجمیع تخلفات خودرو',
        d: 'جمع مبلغ جرایم',
        v: ' 0 ' + priceSymbol,
        bg: 'linear-gradient(135deg,var(--brand),var(--brand-light))',
      },
      {
        icon: <MainIcons.clockIcon fill="#fff" />,
        t: 'وضعیت کارت و سند خودرو',
        d: 'نوع کارت',
        v: 'عادی',
        bg: 'linear-gradient(135deg,var(--green-bright),var(--brand))',
      },
    ],
  };

  return (
    <div className={styles.floatWrap}>
      <div className={styles.card}>
        <div className={styles.head}>
          <span className={styles.cardTitle}>{hero?.cardTitle}</span>
          <span className={styles.liveTag}>
            <span className={styles.liveDot} />
            {hero?.cardLive}
          </span>
        </div>

        {hero?.cardRows?.map((c) => (
          <div key={c.t} className={styles.row}>
            <div className={styles.rowIcon} style={{ background: c.bg }}>
              {c?.icon}
              {/* <Icon id={c.icon} size={19} style={{ color: '#fff' }} /> */}
            </div>
            <div className={styles.rowText}>
              <div className={styles.rowTitle}>{c.t}</div>
              <div className={styles.rowDesc}>{c.d}</div>
            </div>
            <span className={styles.rowValue}>{c.v}</span>
          </div>
        ))}
      </div>

      <div className={styles.scoreCard}>
        <MainIcons.shieldIcon fill="var(--green)" width="20px" height="20px" />
        <div>
          <div className={styles.scoreLabel}>{hero?.scoreLabel}</div>
          <div className={styles.scoreValue}>
            87<span className={styles.scoreMax}>/100</span>
          </div>
        </div>
      </div>
    </div>
  );
}
